import React, { useCallback, useState } from "react";
import { NpsComponentGenericProps } from "../..";
import { Comment, Container } from "./index.styled";
import { Text } from "../../../common";
import { useTheme } from "styled-components";

const LIMIT = 500;

const OpenComponent: React.FC<NpsComponentGenericProps> = ({ question, setAnswer }) => {
    const theme = useTheme();
    const [value, setValue] = useState<string>('');

    const handleSetAnswer = useCallback((e) => {
        const v = e.target.value;
        if (v.length <= LIMIT) {
            setValue(v);
            setAnswer({
                question_id: question.id,
                answer: v,
            });
        }
    }, [question.id, setAnswer]);

    return (
        <Container>
            <Text
                fontSize={16}
                fontWeight={600}
                color={theme.colors.primaryBlue.main}
            >
                {question.label}
            </Text>
            <Comment>
                <textarea value={value} onChange={handleSetAnswer} />
                <span className="counter">{`${value.length}/${LIMIT}`}</span>
            </Comment>
        </Container>
    );
};

export default OpenComponent;
